<template>
  <el-container class="PersonnelVehicleInformation">
    <!-- 单位信息 -->
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="id"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        >
        </el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="单位名称" prop="unitName">
          <el-input
            v-model="tableParams.unitName"
            placeholder="单位名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="法人" prop="legalName">
          <el-input
            v-model="tableParams.legalName"
            placeholder="法人"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="单位类别" prop="unitType">
          <h-selectcode
            type="unitType"
            v-model="tableParams.unitType"
            placeholder="单位类别"
            :clearable="true"
          ></h-selectcode>
        </el-form-item>
        <el-form-item label="经济类型" prop="economicType">
          <h-selectcode
            type="economicType"
            v-model="tableParams.economicType"
            placeholder="经济类型"
            :clearable="true"
          ></h-selectcode>
        </el-form-item>
        <el-form-item label="营业性质" prop="businessPractice">
          <h-selectcode
            type="business_type"
            v-model="tableParams.businessPractice"
            placeholder="营业性质"
            :clearable="true"
          ></h-selectcode>
        </el-form-item>
        <el-form-item>
          <h-button type="primary" @click="refreshTable()">查询</h-button>
          <h-button @click="resetForm(formRef)">重置</h-button>
        </el-form-item>
        <el-row>
          <el-col>
            <h-button
              type="primary"
              @click="addButton"
              :disabled="!tableParams.regionId"
              >添加</h-button
            >
            <h-button type="danger" @click="delUser">删除</h-button>
            <h-button type="primary" @click="uploade">导入</h-button>
            <h-button type="primary" @click="exporting">导出当前页</h-button>
            <h-button type="primary" @click="exportingAll">导出全部</h-button>
            <h-button type="primary" @click="download">模板下载</h-button>
            <input type="file" v-show="false" ref="file" @change="myup" />
          </el-col>
        </el-row>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="unitList"
          :params="tableParams"
          :autoload="false"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <!-- <template #imageUrl="{ row }">
            <span v-if="!row.imageUrl">{{ "暂无" }}</span>
            <img v-else :src="imgURL + row.imageUrl || imgMoren" />
          </template> -->
          <template #unitName="{ row }">
            <div class="table-role" @click="clickTable(row)">
              <span>{{ row.unitName }}</span>
            </div>
          </template>
          <template #regionInfo="{ row }">
            <span>{{
              row.regionInfo && row.regionInfo.levelName.replace(/\//g, "")
            }}</span>
          </template>
        </h-table>
      </div>
    </el-card>
    <unitl-components
      v-model="formVisible"
      :form="userFormData"
      :status="formStatus"
      @submit="userSubmit"
    ></unitl-components>
    <!--  -->

    <!--  -->
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref, watch } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";

import { unitList, unitdelete } from "@/api/management/management";
import {
  getMenutree,
  uploadunit,
  deriveunit,
  downloadunit,
} from "@/api/system/region.js";
import _ from "lodash";
export default defineComponent({
  name: "PersonnelVehicleInformation",
  components: {},
  props: {},
  setup(props) {
    const state = reactive({
      imgURL: window.imgURL,
      flag: false,
      imgMoren: require("@/assets/images/moren.png"),
      filterText: "",
      tableSelection: [],
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      userFormData: {},
      tableParams: {
        unitName: "",
        legalName: "",
        unitType: "",
        economicType: "",
        businessPractice: "",
      },
      tableData: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      columns: [
        { type: "selection" },
        // {
        //   label: "照片",
        //   slot: "imageUrl",
        // },
        {
          label: "单位名称",
          slot: "unitName",
        },
        {
          label: "单位类别",
          prop: "unitTypeDict",
        },
        {
          label: "经济类型",
          prop: "economicTypeDict",
        },
        {
          label: "地址",
          slot: "regionInfo",
        },
        {
          label: "法定代表人",
          prop: "legalName",
        },
        {
          label: "单位联系电话",
          prop: "unitTelphone",
        },
        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
    });
    const refData = toRefs(state);
    const file = ref();
    const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    // 组织树的筛选
    watch(
      () => state.filterText,
      (v) => {
        treeRef.value && treeRef.value.filter(v);
      }
    );
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      console.log(value, data, node);
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      state.tableParams.regionId = item.id;
      state.userFormData.parentId = item.id;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 导入
    const uploade = () => {
      file.value.click();
    };
    const myup = async (e) => {
      var file = e.target.files[0];
      // console.log(files, 123);
      const param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      param.append("chunk", "0"); // 添加form表单中其他数据
      console.log(file.name);
      // if (file.name.substring(11, 15) !== "xlsx") {
      //   state.flag = true;
      // } else {
      const result = await uploadunit(param);
      if (result.code == 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "上传成功",
        });
      }
      console.log("result", result);
      // }
    };
    // 导出
    const exporting = async () => {
      const res = await deriveunit(tableRef.value.form);
      console.log(res);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "c",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };
    // 导出全部
    const exportingAll = async () => {
      const params = {
        allowpage: true,
      };
      const res = await deriveunit(params);
      console.log(res);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };
    // 下载模板
    const download = async () => {
      // const res = await downloadunit();
      // console.log(res);
      // const blob = new Blob([res], {
      //   type: "application/vnd.ms-excel"
      // });
      // const objUrl = URL.createObjectURL(blob);
      // window.location.href = objUrl;
      window.open(window.xlsxUrl + "实有单位信息导入模板.xlsx");
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await getMenutree();
      const treeData = [result.data];
      state.dataSource = treeData;
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.id;
          // treeRef.value.setCurrentKey(state.currentNode.deptId);
        });
        state.rootNodeKey = treeData[0].children[0].id;
      }
    };
    queryOrganTreAsync();
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
        nextTick(() => {});
      } else if (emitKey === "info") {
        // 详情
        state.formStatus = 3; // 把表单设置为查看状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该单位吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            deleteUserAsync([row.unitId]);
          },
          () => {}
        );
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    // 点击添加按钮
    const addButton = () => {
      state.userFormData = {};
      state.formStatus = 1;
      state.formVisible = true;
    };
    const deleteUserAsync = async (ids) => {
      const params = {
        ids: ids,
      };
      const res = await unitdelete(params);
      if (res.code === 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      }
    };
    // 批量删除用户
    const delUser = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox.confirm("您确认要删除选择的单位吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map((item) => item.unitId);
            deleteUserAsync(ids);
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要删除的单位",
        });
      }
    };

    const clickTable = async (item) => {
      state.userFormData = _.cloneDeep(item);
      state.formStatus = 3;
      state.formVisible = true;
    };
    return {
      ...refData,
      clickTable,
      filterNode,
      currentChange,
      addButton,
      refreshTable,
      resetForm,
      delUser,
      hzTableSelect,
      handleClick,
      userSubmit,
      unitList,
      formRef,
      tableRef,
      treeRef,
      exporting,
      exportingAll,
      download,
      uploade,
      file,
      myup,
    };
  },
});
</script>
<style lang="scss" scoped>
.PersonnelVehicleInformation {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      img {
        width: 42%;
        height: 90px;
      }
      .table-role {
        color: #294a7c;
        cursor: pointer;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
